module.exports = __webpack_public_path__ + "static/background-cc2eec07a3d11410eccab38ad8a897e4.png";